import {
  IReservationsContext,
  IReservationsState,
} from "./ReservationsProviderTypes"

export const RESERVATIONS_INITIAL_CONTEXT: IReservationsContext = {
  reservationsData: {},
  reservations: {
    data: [],
    skip: 0,
    take: 10,
    itemCount: 0,
  },
  statusGroups: [],
  washersForFilter: [],
  vehicleBodyTypeGroups: [],
  boxCount: 0,
  boxTotals: {
    availableBoxCount: 0,
    reservedBoxCount: 0,
  },
  boxData: {},
  selectedStatuses: [],
  selectedVehicleTypes: [],
  selectedBoxes: [],
  selectedWashers: [],
  selectedBranchForReservation: 0,
  query: {
    sortBy: "id",
    pageIndex: 1,
    pageSize: 20,
    fromDate: "",
    toDate: "",
  },
  searchValue: "",
  updateReservationBoxLoading: false,
  updateReservationWasherLoading: false,
  recalculateReservationAmountLoading: false,
  updateReservationInfoLoading: false,
  createWebReservationLoading: false,
  cancelReservationLoading: false,
  currentReservationId: null,
  currentReservation: null,
  isReservationDataFetching: false,
  modifiedPrice: null,
  mapData: new Map(),
  carWashScheduleData: {
    data: [
      {
        date: "",
        intervals: [
          {
            time: "",
            isActive: false,
          },
        ],
      },
    ],
  },
  discountTypesData: [],
  carWashWashers: [],
  carWashBoxes: 0,
  selectedDates: [],
  pageSize: { label: "20", value: 20 },
  handleReservationsPageChange: () => {},
  handleMarkReservationAsPrinted: () => {},
  handleSetVehicleKeyStatus: () => {},
  handleClearAllFilters: () => {},
  handleStatusCheckboxClick: () => {},
  handleSelectDatesClick: () => {},
  handleVehicleTypeCheckBox: () => {},
  handleBoxCountCheckbox: () => {},
  handleWashersFilter: () => {},
  handleCancelReservationClick: () => {},
  handleChangeReservationStatusClick: () => {},
  handleSearchChange: () => {},
  handleBoxSelectChange: () => {},
  handleWasherSelectChange: () => {},
  handleViewReservationClick: () => {},
  handleRecalculateReservationAmount: () => {},
  updateReservationInfo: () => {},
  handleCancelReservation: () => {},
  updateReservationStatus: () => {},
  updateSelectedBranchForReservation: () => {},
  createWebReservation: () => {},
  handleTablePageSize: () => {},
  setState: () => {},
}

export const RESERVATIONS_INITIAL_STATE: IReservationsState = {
  reservations: {
    data: [],
    skip: 0,
    take: 10,
    itemCount: 0,
  },
  statusGroups: [],
  washersForFilter: [],
  vehicleBodyTypeGroups: [],
  boxTotals: {
    availableBoxCount: 0,
    reservedBoxCount: 0,
  },
  selectedStatuses: [],
  selectedWashers: [],
  selectedVehicleTypes: [],
  selectedBoxes: [],
  selectedBranchForReservation: 0,
  currentReservationId: null,
  currentReservation: null,
  modifiedPrice: null,
  pageSize: { label: "20", value: 20 },
  searchValue: "",
}

export const RESERVATION_STATUSES: any = {
  1: "onGoing",
  2: "reserved",
  3: "finished",
  4: "canceled",
}

export const RESERVATION_VEHICLEBODYTYPEIDS: any = {
  1: "sedan",
  2: "jeep",
  3: "hatchback",
  4: "motorcycle",
}
